import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Paper, Box, Typography, Divider } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DeptTree from '../../components/deptmng/DeptTree';
import { treeDeparts } from '../../modules/deptModule/departs';


// const data = {
//     id:"root",
//     name:'HC INFO',
//     children:[
//         { id:'90643615-5ce3-11ec-9987-0275bfbe2398',name:'임원실',children:[
//             {id:'0853defe-5ce5-11ec-9987-0275bfbe2398',name:'시스템'},
//             {id:'90643615-5ce3-11ec-9987-0275bfbe2391',name:'임원실'}
//         ]},
//         {id:'5B157EB9-1A0E-4EF1-9EB5-3311EC9DC852',name:'경영기획본부',children:[
//             {id:'6F05E9A0-0BEE-4BBC-BF1B-9C7E03E9FD5D',name:'경영기획본부 본부총괄'},
//             {id:'589BFECB-D3C5-4AB2-B967-85E718EFD97B',name:'인사총무팀'},
//             {id:'265FE7EF-59B9-415E-BFAE-6A44E789C893',name:'재무팀'},
//             {id:'CF96ED8B-4473-4D77-A30E-21B491ADA674',name:'연구소'},
//         ]}
//     ]
// }

const DeptTreeContainer = () => {
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const { departs, error, loading } = useSelector(
        ({ departModule, loading }) => ({
            departs: departModule.departs.departs,
            error: departModule.departs.error,
            loading: loading['depart/TREE_DEPART'],
        }),
    );

    const onHandleClick = (id) => {
        navigate(`/deptmng/${id}`);
    }

    useEffect(() => {
        dispatch(treeDeparts());
    }, [dispatch])

    if (loading || !departs) {
        return null;
    }




    return (
        <Paper>
            <Box 
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                backgroundColor: '#424242',
                color:'#fff',
                py:1,
            }}
            >
                <Box sx={{ mx: 2 }}>
                    <AccountTreeIcon />
                </Box>
                <Typography variant="subtitle2" component="div">
                    조직도
                </Typography>
            </Box>
            <Divider />
            <DeptTree nodes={departs} onHandleClick={onHandleClick} />
        </Paper>
    )
}

export default DeptTreeContainer